<template>
  <label :class="{'dz-drag-hover':dragOver}" class="dropzone white dz-clickable"
         @dragover.prevent="onDragOver" @dragenter.prevent="onDragOver"
         @dragleave.prevent="onDragOut" @dragexit.prevent="onDragOut"
         @drop.prevent="onDrop">
    <span class="dz-message dz-clickable">
      <span v-if="filename">
        <img :src="imgSrc">
      </span>
      <span v-else-if="org">
        <img :src="`/static/uploaded/${org}`">
      </span>
      <span v-else class="mv-30 tc">
        <template v-if="dragSupport">+ 이미지 파일을 드래그해서 추가하시거나 영역을 클릭해서 선택하세요</template>
        <template v-else>클릭해서 파일을 선택하세요</template>
      </span>
      <input :name="name" type="file" accept="image/*" @change="fileSelected">
    </span>
  </label>
</template>
<script>
export default {
  name: 'DropFileInput',
  props: {
    name: { type: String, default: null },
    org: { type: String, default: null },
  },
  data() {
    return {
      dragSupport: false,
      dragOver: false,
      input: null,
      selected: false,
      filename: '',
      imgSrc: '/static/img/img.svg',
    };
  },
  mounted() {
    const el = this.$el;
    this.dragSupport = (('draggable' in el) || ('ondragstart' in el && 'ondrop' in el)) && 'FormData' in window && 'FileReader' in window;
    this.input = this.$el.querySelector('input');
  },
  methods: {
    onDragOver() {
      this.dragOver = true;
    },
    onDragOut() {
      this.dragOver = false;
    },
    onDrop(e) {
      this.dragOver = false;
      this.input.files = e.dataTransfer.files;
    },
    fileSelected() {
      const file = this.input.files[0];
      if ('URL' in window) this.imgSrc = window.URL.createObjectURL(file);
      this.filename = file.name;
    },
    reset() {
      this.filename = '';
    },
    filled() {
      return this.filename || this.$props.org;
    },
  },
};
</script>
<style lang="less" scoped>
  .has-danger .dropzone { border-color:#d9534f;  }
  .dropzone { position:relative; overflow: hidden; border: 1px dotted #666; margin-bottom: 0; padding:10px; }
  span { display: block; }
  label { display: block; }
  input { position: absolute; top:-100px; }
  img { max-width:400px; max-height: 150px; display: block; margin:0 auto; }
</style>



// WEBPACK FOOTER //
// src/components/admin/DropFileInput.vue